import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  updateSpecimen,
  fetchSpecimensByCollectionId,
  fetchSpecimenImagesById,
} from "./actions";
import { Specimen } from "../../types";
import _ from "lodash";

interface SpecimenByCollection {
  specimens: Specimen[];
  count: number;
  loading: boolean;
}

interface SliceStates {
  loading: boolean;
  error: string | null;
  allSpecimens: { [collectionId: string]: SpecimenByCollection };
  // currentCollection: Specimen[];
  currentSpecimen: Specimen | null;
}

const initialState: SliceStates = {
  loading: false,
  error: null,
  allSpecimens: {},
  // currentCollection: [],
  currentSpecimen: null,
};

// Specimen Slice
const specimenSlice = createSlice({
  name: "specimens",
  initialState,
  reducers: {
    // setCurrentCollection: (state, action) => {
    //   state.currentCollection = action.payload;
    // },
    setCurrentSpecimen: (state, action: PayloadAction<Specimen>) => {
      state.currentSpecimen = action.payload;
    },
    clearCurrentSpecimen: (state) => {
      state.currentSpecimen = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateSpecimen.fulfilled, (state, action) => {
        const data = action.payload?.data;
        const specimenId = action.payload?.specimenId;
        const collectionId = action.payload?.collectionId || "";
        if (data && specimenId) {
          state.allSpecimens[collectionId].specimens = (
            state.allSpecimens?.[collectionId].specimens || []
          ).map((specimen) =>
            specimen.id === specimenId ? { ...specimen, ...data } : specimen
          );
          if (state.currentSpecimen?.id === specimenId) {
            state.currentSpecimen = { ...state.currentSpecimen, ...data };
          }
        }
      })
      .addCase(fetchSpecimensByCollectionId.pending, (state, action) => {
        const collectionId = action.meta.arg.collectionId;
        state.allSpecimens[collectionId]["loading"] = true;
        if (!state.allSpecimens[collectionId]) {
          state.allSpecimens[collectionId] = {
            specimens: [],
            count: -1,
            loading: true,
          };
        }

        state.error = null;
      })
      .addCase(fetchSpecimensByCollectionId.fulfilled, (state, action) => {
        if (action.payload) {
          state.loading = false;
          const collectionId = action.meta.arg.collectionId;
          const newSpecimens = _.sortBy(_.uniqBy( [
            ...action.payload.data,
            ...(state.allSpecimens?.[collectionId].specimens || []),
          ], "id"), "trackId");
          state.allSpecimens[collectionId].specimens = newSpecimens;
          state.allSpecimens[collectionId].loading = false;
          state.allSpecimens[collectionId].count = action.payload.count;
        }
      })
      .addCase(fetchSpecimensByCollectionId.rejected, (state, action) => {
        const collectionId = action.meta.arg.collectionId;
        if (!state.allSpecimens[collectionId]) {
          state.allSpecimens[collectionId] = {
            specimens: [],
            count: -1,
            loading: false,
          };
        }
        state.error = "";
      })
      .addCase(fetchSpecimenImagesById.fulfilled, (state, action) => {
        const specimenId = action.payload?.specimenId;
        const collectionId = action.payload?.collectionId || "";
        const images = action.payload?.images;
        state.allSpecimens[collectionId].specimens = [
          ...(state.allSpecimens[collectionId].specimens || []).map(
            (specimen: Specimen) => {
              if (specimen.id === specimenId) {
                return {
                  ...specimen,
                  imgs: images,
                };
              }
              return specimen;
            }
          ),
        ];
        if (state.currentSpecimen?.id === specimenId) {
          state.currentSpecimen = {
            ...state.currentSpecimen,
            imgs: images,
          };
        }
      });
  },
});

export const {
  // setCurrentCollection,
  setCurrentSpecimen,
  clearCurrentSpecimen,
} = specimenSlice.actions;
export default specimenSlice.reducer;
